import { useState, useEffect } from 'react'

/**
 * Hook to preload critical assets
 * Currently disabled to prevent blocking page load
 */
export function usePreloadAssets() {
    const [isLoading, setIsLoading] = useState(false)
    const [error] = useState<string | null>(null)
    const [progress, setProgress] = useState(100)

    useEffect(() => {
        // Immediately set as loaded
        setIsLoading(false)
        setProgress(100)
    }, [])

    return { isLoading, error, progress }
}